/* eslint import/prefer-default-export: 0 */
import { List } from "immutable";

export const getNotifications = (state) => {
	const notifications = state.getIn(["notifications", "active"], List());
	return notifications;
};
